import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { Roles } from '@/common/constants';
import { API_URL } from '@/dtos';

interface Payload {
  employeeId?: string;
  role?: Roles;
}

const useUpdateEmployeeRoleQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.put(API_URL.APPLICATION_USERS_ROLE, {
      employee_id: payload.employeeId,
      role: payload.role,
    })
  );

  return {
    updateEmployeeRole: mutateAsync,
    isLoading,
  };
};

export default useUpdateEmployeeRoleQuery;
